import FlagIcon from '../../components/FlagIcon'

const DealerCard = ({name, website, city, address, zipCode, country}) => {
    const websiteUrl = website.includes('http') ? website : `https://${website}`

    return (
        <a href={websiteUrl} className='mtt-dealer-card' rel='noreferrer noopener' target='_blank'>
            <div className='mtt-dealer-card__title-wrap'>
                <div className='mtt-dealer-card__title-content'>
                    <div className='mtt-dealer-card__flag'>
                        <FlagIcon code={country} width={21} height={15}/>
                    </div>
                    <div className='mtt-dealer-card__title title'>
                        {name}
                    </div>
                </div>
                <div className='mtt-dealer-card__link-icon'>
                    <svg xmlns='http://www.w3.org/2000/svg' width="18.414" height='18.414' viewBox='0 0 18.414 18.414'>
                        <path d='M7 3.414H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4m-4-10h6m0 0v6m0-6-10 10'
                              fill='none' stroke='#000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2'
                              opacity='.4'/>
                    </svg>
                </div>
            </div>
            <div className='mtt-dealer-card__address'>
                {address}
            </div>
            <div className='mtt-dealer-card__address'>
                {zipCode} {city}
            </div>
        </a>
    )
}

export default DealerCard
